/**
 * FAB container, floated above the bottom navigation. Shows the
 * "＋予定追加" extended FAB on the home tab and the small "＋" FAB
 * (add template) on the templates tab.
 */
export default function FabArea({ activeTab, onAddEvent, onAddTemplate }) {
  return (
    <div className="fab-wrap">
      {activeTab === 'home' && (
        <button className="fab" type="button" onClick={onAddEvent}>
          <span className="plus">＋</span>予定追加
        </button>
      )}
      {activeTab === 'templates' && (
        <button className="fab fab-small" type="button" onClick={onAddTemplate}>
          <span className="plus">＋</span>
        </button>
      )}
    </div>
  );
}
